/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerManualRunFromScheduledAodRulesMutationResponse, AuditReportsTriggerManualRunFromScheduledAodRulesPathParams, AuditReportsTriggerManualRunFromScheduledAodRules400, AuditReportsTriggerManualRunFromScheduledAodRules401, AuditReportsTriggerManualRunFromScheduledAodRules403, AuditReportsTriggerManualRunFromScheduledAodRules404 } from "../models/AuditReportsTriggerManualRunFromScheduledAodRules";

export function getAuditReportsTriggerManualRunFromScheduledAodRulesUrl(scheduledJobId: AuditReportsTriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/aod-rules/scheduled-runs/${scheduledJobId}/trigger` as const }
  return res
}

/**
 * @description Triggers a manual AOD run based on an existing scheduled run configuration
 * @summary Trigger a manual AOD run based on a scheduled run
 * {@link /audit-reports/v1/aod-rules/scheduled-runs/:scheduledJobId/trigger}
 */
export async function auditReportsTriggerManualRunFromScheduledAodRules(scheduledJobId: AuditReportsTriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsTriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunFromScheduledAodRules400 | AuditReportsTriggerManualRunFromScheduledAodRules401 | AuditReportsTriggerManualRunFromScheduledAodRules403 | AuditReportsTriggerManualRunFromScheduledAodRules404>, unknown>({ method : "POST", url : getAuditReportsTriggerManualRunFromScheduledAodRulesUrl(scheduledJobId).url.toString(), ... requestConfig })
  return res.data
}